export const addQueryParams = (
  url: string | string,
  params?: Record<string, string | null | boolean | undefined | string[]> | null
) => {
  if (!params) {
    return url
  }
  const searchParams = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (typeof value === "boolean") {
      searchParams.set(key, value ? "true" : "false")
    } else if (value !== null && value !== undefined) {
      searchParams.set(key, String(value))
    }
  })
  if (typeof url === "string") {
    return url + "?" + searchParams.toString()
  }
  return url + "?" + searchParams.toString()
}
